import { BASE_URL, ajax } from './config'
import { params } from '@didi/driver-biz-sdk'
import type {
  InsuranceInfoParams,
  NewInsuranceInfoRes,
  GetCompanyUrlParams,
  GetCompanyUrlRes,
  GetJoinInfoParams,
  GetJoinInfoRes,
  JoinCheckRes,
  JoinCheckParams,
  QueryGrantRes,
  QueryGrantParams,
  GetMyInsurancePoliciesRes,
  GetMyInsurancePoliciesParams,
  GetElectronicsBillParams,
  GetElectronicsBillRes
} from './api-type'

export const getCompanyUrl = ajax.post<GetCompanyUrlRes, GetCompanyUrlParams>(`${BASE_URL}/maple/api/getCompanyUrl`)
export const joinCheck = ajax.post<JoinCheckRes, JoinCheckParams>(
  `${BASE_URL}/maple/api/join/check`,
  {
    paramsWhiteKeys: ['cityId']
  }
)
export const getJoinInfo = ajax.post<GetJoinInfoRes, GetJoinInfoParams>(`${BASE_URL}/maple/api/join/send`)
export const grantQuery = ajax.post<QueryGrantRes, QueryGrantParams>(`${BASE_URL}/maple/api/grantQuery`)
// 自费
export const getMyInsurancePolicies = ajax.get<GetMyInsurancePoliciesRes, GetMyInsurancePoliciesParams>(`${BASE_URL}/maple/api/myInsurancePolicies`)
export const getElectronicsBill = ajax.post<GetElectronicsBillRes, GetElectronicsBillParams>(`${BASE_URL}/maple/api/electronicsBill/query`)

export const getMedicalMergePageInfo = ajax.get<NewInsuranceInfoRes, InsuranceInfoParams>(`${BASE_URL}/maple/api/medicalMergePageInfo`)

const ip = params.urlParams.gmApi
export const sendEseLeads = ajax.post<{
  channel_id: 1 | 2 | 3 // 1.首页,2.邀约页,3.任务列表页
}, unknown>(`//${ip || 'gw.am.xiaojukeji.com'}/ivy/economy/plan/sendEseLeads`)
